import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "value", "children", "label", "error", "className", "autoFocus", "disabled", "topLabel", "onChange", "onClick", "onFocus", "onBlur", "renderEmptyOption"];
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import stl from "./Select.module.css";
var Select = function Select(_ref) {
  var name = _ref.name,
    value = _ref.value,
    children = _ref.children,
    label = _ref.label,
    error = _ref.error,
    className = _ref.className,
    autoFocus = _ref.autoFocus,
    disabled = _ref.disabled,
    topLabel = _ref.topLabel,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$onFocus = _ref.onFocus,
    _onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    _onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    _ref$renderEmptyOptio = _ref.renderEmptyOption,
    renderEmptyOption = _ref$renderEmptyOptio === void 0 ? true : _ref$renderEmptyOptio,
    additionalProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    isFocused = _useState[0],
    setIsFocused = _useState[1];
  var isTargeted = isFocused || !!value;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.selectWrapper, " ").concat(isTargeted ? stl.targeted : "", " ").concat(error ? stl.hasError : "", " ").concat(className ? className : "", " ").concat(isFocused ? stl.focused : "", " ").concat(disabled ? stl.disabled : "", " ").concat(!value ? stl.emptyWrapper : "")
  }, /*#__PURE__*/React.createElement("select", _extends({
    className: !value ? stl.empty : "",
    name: name,
    value: value,
    onChange: onChange,
    onClick: onClick,
    onFocus: function onFocus() {
      _onFocus();
      setIsFocused(true);
    },
    onBlur: function onBlur() {
      _onBlur();
      setIsFocused(false);
    },
    autoFocus: autoFocus,
    disabled: disabled
  }, additionalProps), renderEmptyOption && /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true,
    hidden: true
  }), children), (!topLabel || !isTargeted) && /*#__PURE__*/React.createElement("span", {
    className: stl.label
  }, label), (isTargeted || !label) && /*#__PURE__*/React.createElement("span", {
    className: [stl.label, !label ? stl.fixedTop : undefined].join(" ")
  }, topLabel), error && /*#__PURE__*/React.createElement("span", {
    className: stl.error
  }, error), /*#__PURE__*/React.createElement("i", {
    className: stl.arrIcon
  }));
};
export default Select;